import { LS_KEY_AFTER_LOGIN_PATH } from "@/config/localStorageKeys";
import { EmailAndPasswordSignInForm } from "@/features/auth/components/EmailAndPasswordSignInForm";
import { auth } from "@/libs/firebase";
import { caremeTheme } from "@/libs/theme";
import { Box, Link, Typography } from "@mui/material";
import { Container } from "@mui/system";
import NextLink from "next/link";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAuthState } from "react-firebase-hooks/auth";

export function SigninWithPassword() {
	const router = useRouter();
	const [user, loading] = useAuthState(auth);

	useEffect(() => {
		if (user && !loading) {
			const afterLoginPath = window.localStorage.getItem(
				LS_KEY_AFTER_LOGIN_PATH,
			);
			router.push(afterLoginPath || "/home");
		}
	}, [loading, router, user]);

	return (
		<Container component="main" maxWidth="xs" style={{ padding: 0 }}>
			<Box
				mt={6}
				px={6}
				display="flex"
				flexDirection="column"
				alignContent="center"
			>
				<Typography
					component="h1"
					variant="h6"
					textAlign="center"
					color={caremeTheme.palette.primary.main}
				>
					パスワードでログイン
				</Typography>
				<Typography mt={2} variant="body1" textAlign="center">
					登録したメールアドレスと
					<br />
					パスワードを入力してください
				</Typography>

				<Box mt={2} width="100%">
					<EmailAndPasswordSignInForm />
				</Box>

				<Typography mt={3} variant="body2" textAlign="center">
					<Link
						component={NextLink}
						href="/reset-password"
						underline="none"
						typography="subtitle2"
						color={caremeTheme.palette.primary.main}
					>
						パスワードを忘れた方はこちら
					</Link>
				</Typography>

				<Typography
					mt={3}
					variant="body2"
					textAlign="center"
					color={caremeTheme.palette.grey[400]}
				>
					会員登録はアプリからのみできます
				</Typography>
			</Box>
		</Container>
	);
}
